import {svgIconWrapper} from '../svg-icon-wrapper';

import GlobeAmericaRegular from './globe-america-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GlobeAmericaRegular {...validProps} />;
}

SvgComponent.iconName = 'globeAmericaRegular';

export const GlobeAmericaRegularIcon = svgIconWrapper(SvgComponent);
